import 'promise-polyfill/src/polyfill'
import 'whatwg-fetch'
import 'intersection-observer'
import 'filepond-polyfill'
